import { create } from 'zustand';
import type { VenueId } from '@/api/types';

/**
 * v16: the theme that's live on the call stage right now (a date with a
 * venue, and you said yes to it), so the date and game sheets can carry the
 * place too, and a game moment can swell its sound. Set by VenueStage only.
 */
interface StageVenue {
  venue: VenueId | null;
  swell: () => void;
  set: (venue: VenueId | null, swell?: () => void) => void;
}

const noop = () => undefined;

export const useStageVenue = create<StageVenue>()((set) => ({
  venue: null,
  swell: noop,
  set: (venue, swell) => set({ venue, swell: venue ? (swell ?? noop) : noop }),
}));

/** A line in the place's voice when a game ends ("Loser buys the next cutting chai"). */
export const VENUE_GAME_LINES: Record<VenueId, string[]> = {
  chai_tapri: ['Loser buys the next cutting chai.', 'The rain held off just for that one.', 'Another round? The kettle’s still on.'],
  rooftop_night: ['The whole city saw that.', 'Somewhere below, someone just cheered.', 'One more under the fairy lights?'],
  beach_sunset: ['The waves are taking notes.', 'Golden hour suits a winner.', 'Write the score in the sand.'],
  bookstore_cafe: ['Shh. That one goes in the book.', 'A plot twist nobody saw coming.', 'Bookmark this page.'],
  stargazing: ['Make a wish on that one.', 'Even the stars leaned in.', 'Add another log, play again?'],
  candlelight: ['A toast to that.', 'The candles flickered for that one.', 'One more, while the wax holds out.'],
};

/** A stable pick per game, so both phones show the same line. */
export function venueGameLine(venue: VenueId, gameId: string): string {
  const lines = VENUE_GAME_LINES[venue];
  let h = 0;
  for (let i = 0; i < gameId.length; i++) h = (h * 31 + gameId.charCodeAt(i)) >>> 0;
  return lines[h % lines.length]!;
}
